export default {
  reports: {
    usersByStatus: "Pengguna berdasarkan Status",
    usersByGender: "Pengguna berdasarkan Jenis Kelamin",
    gen: "Jenis Kelamin",
    gender: "Jenis Kelamin",
    male: "Laki-laki",
    female: "Perempuan",
    other: "Lainnya",
    unspecified: "Tidak Disebutkan",
    byCountry: "Berdasarkan Negara",
    avgPriceFarmer: "Harga Rata-rata Petani",
    avgPrice: "Harga Rata-rata",
    selectYear: "Pilih Tahun",
    total: "Total",
    farmerName: "Nama Petani",
    farmerProdChart: "Grafik Produksi Petani",
    production: "Produksi",
    byProduction: "Berdasarkan Produksi",
    byName: "Berdasarkan Nama",
    descending: "Menurun",
    ascending: "Menaik",
    buyingStationProdChart: "Grafik Produksi Stasiun Pembelian",
    buyingStation: "Stasiun Pembelian",
    buyingStationName: "Nama Stasiun Pembelian",
    dryMilling: "Penggilingan Kering",
    dryMillingName: "Nama Penggilingan Kering",
    dryMillingProdChart: "Grafik Produksi Penggilingan Kering",
    view: "Lihat",
    date: "Tanggal",
    reports: "Laporan",
    today: "Hari Ini",
    week: "Minggu",
    month: "Bulan",
    year: "Tahun",
    all: "Semua",
    selectCrop: "Pilih Tanaman",
    selectRegion: "Pilih Wilayah",
    selectProvinceState: "Pilih Provinsi/Negara Bagian",
    downloadPdfReport: "Unduh Laporan PDF",
    export: "Ekspor",
    search: "Cari",
    yield: "Hasil",
    avgAreaPerUnit: "Rata-rata Luas per Unit",
    yieldPerUnit: "Hasil per Unit",
    averageSellingPriceByAllFarmers: "Harga Jual Rata-rata oleh Semua Petani",
    averageSellingPricePerFarmer: "Harga Jual Rata-rata per Petani",
    pricePaid: "Harga Dibayar",
    pests: {
      pestReport: "Laporan Hama",
      filterByCrops: "Saring berdasarkan Tanaman",
      pestStatistics: "Statistik Hama",
      regions: "Wilayah",
      occurrences: "Kejadian",
      pestChart: "Grafik Hama",
      totalArea: "Total Area",
      pestName: "Nama Hama",
      region: "Wilayah",
      crop: "Tanaman",
      listByLand: "Daftar berdasarkan Lahan",
    },
    regions: {
      regionalReport: "Laporan Regional",
      listByFarm: "Daftar berdasarkan Pertanian",
      listByFarmers: "Daftar berdasarkan Petani",
      listByYield: "Daftar berdasarkan Hasil",
      regionalStatistics: "Statistik Regional",
      countries: "Negara",
      states: "Negara Bagian/Provinsi",
      city: "Kota",
      farmsIn: "Pertanian di",
      regionalChart: "Grafik Regional",
      farms: "Pertanian",
      regionName: "Nama Wilayah",
      farmers: "Petani",
      yield: "Hasil",
    },
    dashboard: {
      topCharts: "Grafik Teratas",
      regions: "Wilayah",
      noOfFarms: "Jumlah Pertanian",
      provinces: "Provinsi",
      landArea: "Luas Lahan",
      avgFarmerLand: "Lahan Petani Rata-rata",
      viewAll: "Lihat Semua",
      crops: "Tanaman",
      plantedAreaCrop: "Area Tanam Tanaman",
      plantedArea: "Area Tanam",
      avgYieldCrop: "Hasil Rata-rata Tanaman",
      averageYield: "Hasil Rata-rata",
      yieldChart: "Grafik Hasil",
      selectFarm: "Pilih Pertanian",
      soilQuality: "Kualitas Tanah",
      pests: "Hama",
      occurrences: "Kejadian",
      equipments: "Peralatan",
      goalAchievedChart: "Grafik Pencapaian Target",
      soilValues: "Nilai Tanah",
      soil: "Tanah",
      showReport: "Tampilkan Laporan",
      selectAll: "Pilih Semua",
    },
    weight: "Berat",
    quality: "Kualitas",
    price: "Harga",
  },
}